export function throttleRaf<T>(fn: (args: T) => void): (args: T) => void;
export function throttleRaf(fn: () => void): () => void;
export function throttleRaf<T>(fn: (args?: T) => void) {
  let scheduled = false;

  return (args?: T) => {
    if (scheduled) {
      return;
    }

    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      fn(args);
    });
  };
}
